module.exports = __webpack_public_path__ + "images/639fe609bbc2dea5757ac2e3163f117b.png";